module.exports = __webpack_public_path__ + "static/licence-and-approval-circles-8bb991c989b6b7c2d6d45872a3894262.png";